import React from 'react';
import { TermsLayout } from '@meettry/engineer/components/templates/TermsLayout';

const Tokutei = () => {
  return <TermsLayout file="tokutei" />;
};

export default Tokutei;
